define('app/dashboard/Dashboard',['require','./DashboardFilterView','./DashboardListView','glu/itemView','glu/model','./dialogs/SelectWidgetsDialogView','./dialogs/SelectBenchmarksDialogView','./dialogs/AddDashboardDialogView','config','glu/dialog','glu/util','glu/util','glu/$','app/app','glu/http','./panels/DashboardPanel','./panels/SharedDashboardPanel','./panels/ConversionDashboardPanel','./panels/DecisionDashboardPanel','./panels/MarketingDashboardPanel','./panels/FundingDashboardPanel','./panels/BenchmarkDashboardPanel','app/models/BenchmarkCollection','./panels/SegmentDashboardPanel','./panels/MetricDashboardPanel','./panels/AlertsDashboardPanel','hbs!./Dashboard.hbs'],function(require) {

	'use strict';

	var DashboardFilterView = require('./DashboardFilterView'),
		DashboardListView = require('./DashboardListView'),
		ItemView = require('glu/itemView'),
		Model = require('glu/model'),
		SelectWidgetsDialogView = require('./dialogs/SelectWidgetsDialogView'),
		SelectBenchmarksDialogView = require('./dialogs/SelectBenchmarksDialogView'),
		AddDashboardDialogView = require('./dialogs/AddDashboardDialogView'),
		config = require('config'),
		dialog = require('glu/dialog'),
		_ = require('glu/util'),
		log = require('glu/util'),
		$ = require('glu/$'),
		APP = require('app/app'),
		http = require('glu/http'),
		DashboardPanel = require('./panels/DashboardPanel'),
		SharedDashboardPanel = require('./panels/SharedDashboardPanel'),
		ConversionDashboardPanel = require('./panels/ConversionDashboardPanel'),
		DecisionDashboardPanel = require('./panels/DecisionDashboardPanel'),
		MarketingDashboardPanel = require('./panels/MarketingDashboardPanel'),
		FundingDashboardPanel = require('./panels/FundingDashboardPanel'),
		BenchmarkDashboardPanel = require('./panels/BenchmarkDashboardPanel'),
		BenchmarkCollection = require('app/models/BenchmarkCollection'),
		SegmentDashboardPanel = require('./panels/SegmentDashboardPanel'),
		MetricDashboardPanel = require('./panels/MetricDashboardPanel'),
		AlertsDashboardPanel = require('./panels/AlertsDashboardPanel');


	return ItemView.extend({

		className: 'page-dashboard',
		template: require('hbs!./Dashboard.hbs'),

		http: http,

		ui: {
			dashboardListWrapper: '.dashboard-list-wrapper',
			$selectedUser: '.select-user'
		},

		serializeData: function() {
			return this;
		},

		dialog: dialog,

		initialize: function() {
			var self = this;
			this.dashboardListView = new DashboardListView({
				collection: this.collection
			});
			this.listenTo(this.dashboardListView, 'change:selection', this.showSelectedDashboard);
			this.listenTo(this.collection, 'change:edited', function() {
				self.showSelectedDashboard();
			});
			this.lastSelectedUser = 'default';

			http.get(config.apiRoot + 'service/benchmarks').then(function(res) {
				self.benchmarkCollection = res && res.data ? new BenchmarkCollection(res.data) : new BenchmarkCollection();
			});
		},

		events: {
			'click .add-widget-button': 'createNewWidget',
			'click .dashboard-empty-state .add-widget': 'createNewWidget',
			'click .add-benchmark-button': 'createNewBenchmark',
			'click .dashboard-empty-state .add-benchmark': 'createNewBenchmark',
			'click #create-dashboard-button': 'createNewDashboard',
			'change .select-user': 'changeUserSelection'
		},

		onClose: function() {
			if (this.panel) {
				this.panel.close();
			}
			if (this.dashboardListView) {
				this.dashboardListView.close();
			}
			if (this.filterView) {
				this.filterView.close();
			}
		},

		onRender: function() {
			this.ui.dashboardListWrapper.empty().append(this.dashboardListView.render().el);
			if (APP.user.isInternalUser()) {
				this.$('#create-dashboard-button').hide();
				var username = APP.user.getLastSelectedUserInternal();
				if (username) {
					this.showSelectedUser(APP.user.getLastSelectedUserInternal(), false);
					this.$el.find(this.ui.$selectedUser).val(username);
				}
				this.ui.$selectedUser.comboBox();
				this.showSelectedDashboard();
			} else {
				this.showSelectedDashboard();
			}
		},

		/**
		 * Render a new domain-appropriate dashboard panel instance.
		 */
		renderDashboardPanel: function(dashboard) {
			var self = this,
				el = self.$('.dashboard-tabs-container')[0];

			if (this.panel) {
				this.panel.killEventListeners();
			}

			if (dashboard.get('dashboardType') === 'FIXED') {
				if (dashboard.get('layout') === 'CONVERSION') {
					this.panel = new ConversionDashboardPanel({
						model: dashboard,
						el: el
					}).render();
				} else if (dashboard.get('layout') === 'DECISION') {
					this.panel = new DecisionDashboardPanel({
						model: dashboard,
						el: el
					}).render();
				} else if (dashboard.get('layout') === 'MARKETING') {
					this.panel = new MarketingDashboardPanel({
						model: dashboard,
						el: el
					}).render();
				} else if (dashboard.get('layout') === 'FUNDING') {
					this.panel = new FundingDashboardPanel({
						model: dashboard,
						el: el
					}).render();
				} else if (dashboard.get('layout') === 'FUNDING FAILURE') {
					this.panel = new FundingDashboardPanel({
						model: dashboard,
						el: el
					}).render();
				} else {
					throw new Error('Dashboard layout is unknown');
				}
			} else if (dashboard.get('dashboardType') === 'SHARED') {
				this.panel = new SharedDashboardPanel({
					model: dashboard,
					el: el
				}).render();
			} else if (dashboard.get('layout') === 'BENCHMARK') {
				this.panel = new BenchmarkDashboardPanel({
					model: dashboard,
					el: el
				}).render();
			} else if (dashboard.get('layout') === 'SEGMENTS') {
				this.panel = new SegmentDashboardPanel({
					model: dashboard,
					el: el
				}).render();
			} else if (dashboard.get('layout') === 'ALERTS') {
				this.panel = new AlertsDashboardPanel({
					model: dashboard,
					el: el
				}).render();
			} else if (dashboard.get('layout') === 'METRICS') {
				this.panel = new MetricDashboardPanel({
					model: dashboard,
					el: el
				}).render();
			} else {
				this.panel = new DashboardPanel({
					model: dashboard,
					el: el
				}).render();
			}
		},

		showSelectedDashboard: function() {
			var dashboard = this.dashboardListView.selectedDashboard();

			var self = this;

			this.appBus.trigger('nav:dashboard', dashboard);

			if (dashboard) {

				this.renderDashboardPanel(dashboard);

				var filterDomain = APP.domains.at(0);

				if (filterDomain) {
					filterDomain.fetch().then(function() {
						// copy some properties from the first domain so the dashboard can support filtering
						dashboard.set('fields', filterDomain.get('fields'));
						dashboard.set('dashboardOptions', filterDomain.get('domainOptions'));

						if (self.filterView) {
							self.filterView.close();
						}

						self.filterView = self.createDashboardFilterView(dashboard);

						if (dashboard.get('layout') !== 'ALERTS') {
							var renderedFilterView = self.filterView.render().el;

							$(renderedFilterView).find('label.filter-field-name').text('Time frame');

							self.$('.dashboard-filter-form').empty().append(renderedFilterView); // TODO: The view should be initialized with filterForm as its el.
						}
					});
				}

				self.$el.addClass('is-dashboard-selected');
			} else {
				this.$el.removeClass('is-dashboard-selected');
			}
		},

		showSelectedUser: function(username) {
			if (username !== undefined) {
				var self = this;
				// hide the button
				if (username !== APP.user.getUsername()) {
					this.$('#create-dashboard-button').hide();
				} else {
					this.$('#create-dashboard-button').show();
				}

				if (username === 'default') {
					this.collection.reset(self.collection.fetch().then(function() {
						self.dashboardListView.selectFirstDashboard();
						self.dashboardListView.render();
					}));
				} else {
					this.collection.fetch().then(function() {
						self.dashboardListView.filterUserDashboards(username);
						self.dashboardListView.selectFirstDashboard();
						self.dashboardListView.render();
					});
				}
			}
		},

		createDashboardFilterView: function(dashboard) {
			dashboard.initMasterFilter();

			return new DashboardFilterView({
				fieldCollection: dashboard.dateFields(),
				model: dashboard.getMasterFilter(),
				dashboard: dashboard
			});
		},

		createNewBenchmark: function() {
			var dashboard, self = this;

			dashboard = this.dashboardListView.selectedDashboard();

			if (dashboard) {
				self.selectBenchmarksDialogView = new SelectBenchmarksDialogView({
					className: 'modal-select-benchmarks',
					model: new Model({
						benchmarkCollection: self.benchmarkCollection
					})
				});

				self.listenTo(this.selectBenchmarksDialogView, 'selectBenchmarks', function(ids) {
					var addedBenchmarkPromises = [],
						deferredRequests,
						payload = {};

					_.each(ids, function(id) {
						payload.dashboardId = dashboard.id;
						payload.benchmarkId = id;

						addedBenchmarkPromises.push($.ajax(config.apiRoot + 'service/benchmarks', {
							type: 'POST',
							contentType: 'application/json',
							data: JSON.stringify(payload)
						}));
					});

					// Refresh dashboard after benchmarks have been added.
					deferredRequests = $.when.apply($, addedBenchmarkPromises);
					deferredRequests.done(function() {
						self.dashboardListView.selectDashboardById(dashboard.id, false);
					});
					self.dialog.close();
				});
				self.dialog.open(this.selectBenchmarksDialogView, 'Select Benchmarks');
			} else {
				throw new Error('createNewBenchmark() was called but no domain selected. Cannot create a report without specifying a domain');
			}
		},

		// pops up the widget selection dialog and saves the report
		createNewWidget: function(e) {
			var widgetType, dashboard, self = this;

			// Which type are we trying to add?
			if ($(e.target).hasClass('top-10') || $(e.target).parent().hasClass('top-10')) {
				widgetType = 'top-10';
			} else if ($(e.target).hasClass('chart') || $(e.target).parent().hasClass('chart')) {
				widgetType = 'chart';
			} else if ($(e.target).hasClass('kpi') || $(e.target).parent().hasClass('kpi')) {
				widgetType = 'kpi';
			}

			dashboard = this.dashboardListView.selectedDashboard();

			if (dashboard) {
				var domains = APP.domains;

				self.selectWidgetsDialogView = new SelectWidgetsDialogView({
					className: 'modal-select-widgets',
					model: new Model({
						domains: domains,
						widgetType: widgetType
					})
				});

				self.listenTo(this.selectWidgetsDialogView, 'selectFields', function(ids) {
					var addedWidgetPromises = [],
						deferredRequests;

					_.each(ids, function(id) {
						// id includes both the domain id and the widgets id separated by '+'
						var idList = id.split('+');
						var domainId = idList[0];
						var widgetId = idList[1];

						// get the domain
						var domainOfWidget = APP.domains.find(function(d) {
							return d.id === domainId;
						});

						if (domainOfWidget !== null) {
							var report = domainOfWidget.getWidgetById(widgetId);
							// unset the id now so that a new report is created
							report.id = null;
							report.domainId = domainId;
							report.dashboardId = dashboard.id;
							report.isPrivate = true;

							addedWidgetPromises.push($.ajax(config.apiRoot + 'service/reports', {
								type: 'POST',
								contentType: 'application/json',
								data: JSON.stringify(report)
							}));
						} else {
							log.warn('Unexpected Error: Domain of the widget is unknown!');
						}
					});

					// Refresh dashboard after widgets have been added.
					deferredRequests = $.when.apply($, addedWidgetPromises);
					deferredRequests.done(function() {
						self.dashboardListView.selectDashboardById(dashboard.id, false);
					});
					self.dialog.close();
				});
				self.dialog.open(this.selectWidgetsDialogView, 'Select Widgets');
			} else {
				throw new Error('createNewWidget() was called but no domain selected. Cannot create a report without specifying a domain');
			}
		},

		setDashboardDialog: function(dashboardList) {
			var self = this;
			self.addDashboardView = new AddDashboardDialogView(dashboardList);

			self.dialog.open(self.addDashboardView, 'Add Dashboard');


			self.listenTo(self.addDashboardView, 'addDashboard', function(id) {
				self.dialog.close();

				var username = self.$el.find(self.ui.$selectedUser).val();
				if (username !== undefined && username !== null) {
					self.collection.fetch().then(function() {
						self.dashboardListView.filterUserDashboards(username);
						self.dashboardListView.onDashboardAdded(id);
					});
				} else {
					self.collection.fetch().then(function() {
						self.dashboardListView.onDashboardAdded(id);
					});
				}
			});
		},

		createNewDashboard: function() {
			var self = this;
			return this.http.get(config.apiRoot + 'service/publicdashboards').then(function(results) {
				// remove the ones already selected
				var dashboards = results.data;
				var ids = self.collection.pluck('id');
				var notAdded = dashboards.filter(function(d) {
					return (ids.indexOf(d.id) < 0);
				}, ids);
				self.setDashboardDialog(notAdded);
			}, function() {
				self.setDashboardDialog([]);
			});
		},

		userOptions: function() {
			var users = APP.users;

			return users.map(function(user) {
				return {
					value: user.get('username'),
					label: user.get('username')
				};
			});
		},

		changeUserSelection: function() {
			var username = this.$el.find(this.ui.$selectedUser).val();

			APP.user.setLastSelectedUserInternal(username);
			this.showSelectedUser(username, true);
		}
	});


});

